'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var rafThrottle = function rafThrottle(callback) {
  var requestId = void 0;

  var later = function later(args) {
    return function () {
      requestId = null;
      callback.apply(undefined, _toConsumableArray(args));
    };
  };

  var throttled = function throttled() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (requestId == null) {
      requestId = (0, _raf2.default)(later(args));
    }
  };

  throttled.cancel = function () {
    return _raf2.default.cancel(requestId);
  };

  return throttled;
};

exports.default = rafThrottle;


//////////////////
// WEBPACK FOOTER
// ./~/raf-throttle/lib/index.js
// module id = 144
// module chunks = 0